import React from "react";
import Loadable from "../../react-loadable";
import "./style/index.less";

const WeaCityPicker = Loadable({
  loader: () => import("./CityPicker"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaCityPicker;



// WEBPACK FOOTER //
// ./ecology9/wea-city-picker/index.js